class Procedures {
  constructor() {
    this.procedures = []
  }

  add = (procedure) => {
    this.procedures.push(procedure)
    procedure.install()
  }

  remove = (procedureName) => {
    this.procedures.forEach((procedure) => {
      if (procedure.name === procedureName) {
        procedure.uninstall()
      }
    })
  }

  close() {
    this.procedures.forEach((procedure) => {
      procedure.uninstall()
    })
  }

  get = (procedureName) => {
    return this.procedures.find((procedure) => procedure.name === procedureName)
  }
}

const procedures = new Procedures()
export {procedures}
